import { isMobile } from "@/util/viewport";

// Options-API bridge for the shared viewport flag.
//
// Components used to declare `is_mobile() { return window.innerWidth <= 768; }`
// as a computed. `window.innerWidth` is not reactive, so Vue cached the first
// value and never recomputed it — rotating a phone or dragging a desktop window
// across the breakpoint left the stale layout rendered. Reading the shared ref
// gives the computed a real dependency.
export default {
  computed: {
    is_mobile() {
      return isMobile.value;
    },
  },
};
